<template>
  <home-template>
    <div class="text-start" slot="content">
      <div class="top-container">
        <v-row class="top-container-title-label">
          <div class="text-title" v-if="isEditMode">Visitor parking</div>
          <div class="text-title" v-else>Add visitor parking</div>
        </v-row>
        <v-row class="tabs tabs-with-paddings">
          <v-tabs v-model="tab">
            <v-tab v-show="showIntagrationTab" class="pl-0">
              Integrations
            </v-tab>
            <v-tab :class="{ 'pl-0': !showIntagrationTab }"> Pricing </v-tab>
            <v-tab> Discounts </v-tab>
            <v-tab> {{ $t("tab_restrictions") }} </v-tab>
            <v-tab> Instructions </v-tab>
            <v-tab v-if="auth.isParkmanAdmin()"> Advanced settings </v-tab>

            <v-col class="button-panel">
              <v-row>
                <v-spacer />
                <v-btn
                  v-if="isPricingTab && auth.isParkmanAdmin()"
                  class="pkmn-button add-price-schedule-button"
                  color="primary"
                  @click="openPricingScheduleForm"
                >
                  Add price schedule
                </v-btn>
                <v-btn
                v-if="isRestrictionTab"
                  class="pkmn-button add-price-schedule-button"
                  color="primary"
                  @click="showAddRestrictionsForm"
                >
                {{ $t('add_restrictions') }}
              </v-btn>
              </v-row>
            </v-col>
          </v-tabs>
        </v-row>
      </div>

      <v-row>
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-show="showIntagrationTab"
            class="tab-item with-horizontal-padding"
          >
            <v-divider />
            <tab-integrations 
            :hubsList="hubsList" 
            :wardensList="wardensList"
            :cameraConnection="cameraConnection"
            :anprConfig="anprConfig"
            @add="addWarden"
            @delete="deleteWarden"
            @addHub="openAddHubForm"
            @deleteHub="isShowingDeleteHubPopup = true"
            @addANPR="showAddANPRPopup"
            @deleteAnpr="deleteAnpr"
            />
          </v-tab-item>
          <v-tab-item class="tab-item with-horizontal-padding">
            <v-divider :class="{ 'pricing-divider': auth.isParkmanAdmin() }" />
            <tab-pricing
              ref="tabPricing"
              :currencyId="locationCurrencyId"
              :prices="schedulePrices"
              @pricigScheduleList="pricigScheduleList = { ...$event }"
              @priceItemChanged="currentPriceItem = $event"
              @edit="editSchedule"
            />
          </v-tab-item>
          <v-tab-item class="tab-item with-horizontal-padding">
            <v-divider />
            <tab-discounts
            :discounts="discounts"
            :isLocationProduct="true"
            @edit="openEditDiscountForm"
            @view="openCountryHolidaysPopup"
            @delete="openDeleteDiscountConfirm"
            @close="isEcoCarDiscountFormOpening = false"
            @showLocations="openDiscountedLocationsForm"/>
          </v-tab-item>
          <v-tab-item class="tab-item with-horizontal-padding">
            <v-divider />
            <tab-restrictions
            :backendData="allowedTime"
            @edit="showEditAllowedTimeForm"/>
          </v-tab-item>
          <v-tab-item class="tab-item with-horizontal-padding">
            <v-divider />
            <tab-instruction
              @edit="editInstruction"
              :locationId="locationId"
              @openAddForm="openAddForm"
            />
          </v-tab-item>
          <v-tab-item class="tab-item with-horizontal-padding">
            <v-divider />
            <advanced-settings-tab
              ref="tabAdvancedSettings"
              :productSettings="productSettings"
              :locationName="locationName"
              :merchantName="merchantName"
              @changed="productSettingsChanged = $event"
              @validated="productSettingsValid = $event"
              @formData="productSettingsFormData = $event"
              @delete="deleteLocationProduct"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-row>

      <form-set-pricing-schedule
        v-if="isPricingScheduleFormOpenings"
        :editItem="editingScheduleItem"
        :currencyId="locationCurrencyId"
        @close="isPricingScheduleFormOpenings = false"
        @submit="submitPricingSchedule"
        @update="updatePricingSchedule"
        @delete="deletePricingSchedule"
      />
      <add-new-instruction-form
        v-if="isShowingAddForm"
        :editMode="addFormEditMode"
        :instructionTypeId="instructionTypeId"
        :locationId="locationId"
        @close="isShowingAddForm = false"
      />
      <currency-approve-popup
        :showPopup="showCurrencyApprovePopup"
        @approve="sendForReview"
        @close="showCurrencyApprovePopup = false"
      />

      <form-eco-car-discount
      v-if="isEcoCarDiscountFormOpening"
      :discount="selectedDiscount"
      :isLocationProduct="true"
      :locationProductIds="[currentLocationProductId()]"
      mode="edit"
      @close="isEcoCarDiscountFormOpening = false"
      />

      <form-holidays-popup
      v-if="isHolidaysFormOpening"
      :holidays="holidays"
      :discount="selectedDiscount"
      mode="edit"
      :isLocationProduct="true"
      @close="isHolidaysFormOpening = false"
      @save="saveDiscount"
      />
      <form-discount-locations-popup
      v-if="isDiscountLocationsFormOpening"
      :locations="discountLocations"
      @close="isDiscountLocationsFormOpening = false"
      />
      <form-country-holidays-popup
      v-if="isCountryHolidaysPopupOpening"
      :holidays="holidays"
      :discount="selectedDiscount"
      @close="isCountryHolidaysPopupOpening = false"
      />
      <form-delete-discount
        v-if="isDeleteDiscountConfirmOpening"
        @close="isDeleteDiscountConfirmOpening = false"
        @confirm="confirmDeleteDiscount"
      />
      <v-card
        elevation="6"
        class="bottom-navigation"
        v-if="showBottomNavigation"
      >
        <v-card-actions class="justify-end">
          <v-btn
            v-if="showActivatePricing"
            class="pkmn-button mx-1 bottom-button"
            color="primary"
            @click="checkCurrencyApproval"
          >
            Activate pricing
          </v-btn>
          <v-btn
            v-if="false"
            class="pkmn-button mx-1"
            color="warning"
            outlined
            @click="withdrawReview()"
          >
            Withdraw review request & Edit
          </v-btn>
          <v-btn
            v-if="!hideNextBtn"
            class="pkmn-button bottom-button"
            color="primary"
            :outlined="isScheduleInReview ? false : true"
            @click="openNextTab"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card
        elevation="6"
        class="bottom-navigation"
        v-if="isAdvancedSettingsTab && productSettingsChanged"
      >
        <v-card-actions class="justify-end">
          <v-btn
            v-if="isEditMode"
            class="pkmn-button bottom-button"
            color="primary"
            outlined
            @click="cancelChanges"
          >
            Cancel changes
          </v-btn>
          <v-btn
            v-if="isEditMode"
            class="pkmn-button pkmn-button--has-border bottom-button"
            color="primary"
            :outlined="false"
            :disabled="!productSettingsValid"
            @click="updateProductSettings"
          >
            Save
          </v-btn>
          <v-btn
            v-else
            class="pkmn-button pkmn-button--has-border bottom-button"
            color="primary"
            :outlined="false"
            :disabled="!productSettingsValid"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
      <form-add-hub-popup
        v-if="isShowingAddHubPopup === true"
        :hubList="merchantHubsList"
        @close="isShowingAddHubPopup = false"
        @add="addHub"
      />
      <form-delete-hub-popup
        v-if="isShowingDeleteHubPopup === true"
        @close="isShowingDeleteHubPopup = false"
        @delete="deleteHub"
      />
      <form-add-restrictions
      v-if="isShowingAddRestrictionsPopup === true"
      :data="editAllowedTimeItem"
      @close="isShowingAddRestrictionsPopup = false"
      @submit="submitAllowedTime"
      />
      <form-add-a-n-p-r
      v-if="isShowingAddANPRForm === true"
      :anprList="anprConfig.integrators"
      :startParkingOption="anprConfig.features.start"
      :stopParkingOption="anprConfig.features.stop"
      @close="isShowingAddANPRForm = false"
      @add="addAnprConnection"
      />
    </div>
  </home-template>
</template>

<script>
import auth from '@/auth'
import HomeTemplate from '@/templates/Locations'
import TabPricing from '@/components/Locations/AddVisitorParking/Tab/TabPricing.vue'
import AdvancedSettingsTab from '@/components/Locations/AddVisitorParking/Tab/AdvancedSettingsTab.vue'
import FormSetPricingSchedule from '@/components/Locations/AddVisitorParking/Form/FormSetPricingSchedule.vue'
import merchantHelpers from '@/helpers/merchant'
import TabInstruction from '@/components/Locations/Location/InstructionForm.vue'
import AddNewInstructionForm from '@/components/Locations/Location/FormAddNewInstruction.vue'
import CurrencyApprovePopup from '@/components/Locations/AddVisitorParking/CurrencyApprovePopup.vue'
import TabIntegrations from '@/components/Locations/AddVisitorParking/Tab/TabIntegrations.vue'
import * as config from '@/config/config'
import { mapGetters } from 'vuex'

import FormEcoCarDiscount from '@/components/Merchant/Form/FormEcoCarDiscount.vue'
import FormHolidaysPopup from '../../components/Merchant/Form/FormHolidaysPopup.vue'
import FormDiscountLocationsPopup from '../../components/Merchant/Form/FormDiscountLocationsPopup.vue'
import FormCountryHolidaysPopup from '../../components/Merchant/Form/FormCountryHolidaysPopup.vue'
import FormDeleteDiscount from '../../components/Merchant/Form/FormDeleteDiscount.vue'
import TabDiscounts from '@/components/Merchant/Tab/Merchant/MerchantDiscounts.vue'
import FormAddHubPopup from '@/components/Locations/AddVisitorParking/Subtabs/FormAddHubPopup.vue';
import FormDeleteHubPopup from '@/components/Locations/AddVisitorParking/Subtabs/FormDeleteHubPopup.vue'

import TabRestrictions from '../../components/Locations/AddVisitorParking/Tab/TabRestrictions.vue'
import FormAddRestrictions from '../../components/Locations/AddVisitorParking/Form/FormAddRestrictions.vue'
import FormAddANPR from '../../components/Locations/AddVisitorParking/Form/FormAddANPR.vue'
const ACTIVE_STATUS_ID = 3

const TAB = {
  // PAYOUTS: 0,
  DISCOUNTS: 2,
  PRICING: 1,
  INTRODUCTIONS: 4,
  INTERGRATIONS: 0,
  ADVANCED_SETTINGS: 5,
  RESTRICTIONS: 3
}

export default {
  name: 'AddVisitorParking',

  components: {
    HomeTemplate,
    TabPricing,
    FormSetPricingSchedule,
    TabInstruction,
    AddNewInstructionForm,
    AdvancedSettingsTab,
    CurrencyApprovePopup,
    TabIntegrations,
    FormEcoCarDiscount,
    FormHolidaysPopup,
    FormDiscountLocationsPopup,
    FormCountryHolidaysPopup,
    FormDeleteDiscount,
    TabDiscounts,
    FormAddHubPopup,
    FormDeleteHubPopup,
    TabRestrictions,
    FormAddRestrictions,
    FormAddANPR
  },

  data() {
    return {
      auth: auth,
      isTapPricing: false,
      isPricingScheduleFormOpenings: false,
      tab: '',
      percent: 0,
      currentPriceItem: 0,
      isScheduleInReview: false,
      schedulePrices: [],
      editingScheduleItem: null,
      productSettings: {},
      productSettingsFormData: {},
      productSettingsChanged: false,
      productSettingsValid: false,
      isShowingAddForm: false,
      addFormEditMode: false,
      instructionTypeId: 0,
      pricigScheduleList: {},
      showCurrencyApprovePopup: false,
      hubsList: [],
      wardensList: [],
      discounts: [],
      isEcoCarDiscountFormOpening: false,
      selectedDiscount: null,
      isHolidaysFormOpening: false,
      holidays: [],
      discountLocations:[],
      isDiscountLocationsFormOpening: false,
      isCountryHolidaysPopupOpening: false,
      isDeleteDiscountConfirmOpening: false,
      deletingDiscount: null,
      isShowingAddHubPopup: false,
      merchantHubsList: [],
      isShowingDeleteHubPopup: false,
      isShowingAddRestrictionsPopup: false,
      allowedTime: [],
      editAllowedTimeItem: null,
      isShowingAddANPRForm: false,
      cameraConnection: null,
      anprConfig: null
    }
  },

  computed: {
    ...mapGetters([
      'currentProductSettings',
      'currentMerchant',
      'currentLocation'
    ]),
    merchantName() {
      return this.currentMerchant?.name
    },
    locationName() {
      return this.currentLocation?.name
    },
    isPricingActive() {
      return Object.keys(this.pricigScheduleList)?.length
        ? this.pricigScheduleList.schedule[0].status_id === ACTIVE_STATUS_ID
        : false
    },
    locationCurrencyId() {
      if (this.currentLocation) {
        return this.currentLocation.currency_id
      }
      return 0
    },
    isEditMode() {
      return true // TODO add condition when add product functionality is ready
    },
    isPayoutsTab() {
      return false
    },
    isIntegrationTab() {
      return this.tab === TAB.INTERGRATIONS
    },
    isPricingTab() {
      return this.tab === TAB.PRICING
    },
    isIntroductionsTab() {
      return this.tab === TAB.INTRODUCTIONS
    },
    isDiscountsTab() {
      return this.tab === TAB.DISCOUNTS
    },
    isRestrictionTab() {
      return this.tab === TAB.RESTRICTIONS
    },
    isAdvancedSettingsTab() {
      return this.tab === TAB.ADVANCED_SETTINGS
    },
    locationId() {
      return parseInt(this.$route.params.locationId)
    },
    hideNextBtn() {
      return !this.isIntegrationTab
    },
    showActivatePricing() {
      return (
        (this.pricigScheduleList?.weekdayPaidTimes &&
          this.pricigScheduleList?.weekdayPaidTimes?.length) ||
        (this.pricigScheduleList?.sequencePriceSteps?.steps &&
          this.pricigScheduleList?.sequencePriceSteps?.steps?.length) ||
        (this.pricigScheduleList?.periodicPriceItems?.items &&
          this.pricigScheduleList?.periodicPriceItems?.items?.length)
      )
    },
    showBottomNavigation() {
      return (
        !this.isPricingActive &&
        this.isPricingTab &&
        auth.isParkmanAdmin() &&
        (this.showActivatePricing || !this.hideNextBtn)
      )
    },
    showIntagrationTab() {
      // Add checking all lists from intagration tab
      return true
    },
    wardensUrl() {
      return this.$route.name === 'Merchant'
        ? auth.isParkmanAdmin()
          ? `admin/merchants/${this.$route.params.merchantId}/warden`
          : `merchants/${this.$route.params.merchantId}/warden`
        : auth.isParkmanAdmin()
        ? `admin/merchants/${this.$route.params.merchantId}/locations/${this.$route.params.locationId}/warden`
        : `merchants/${this.$route.params.merchantId}/locations/${this.$route.params.locationId}/warden`
    }
  },

  watch: {
    tab(newValue) {
      if (this.isPayoutsTab) {
        this.percent = 0
      } else if (this.isIntegrationTab) {
        this.percent = 16
      } else if (this.isPricingTab) {
        this.percent = 33
      } else if (this.isIntroductionsTab) {
        this.percent = 49
      } else if (this.isDiscountsTab) {
        this.percent = 66
        this.fetchLocationProductsDiscounts()
      } else if (this.isRestrictionTab) {
        this.fetchAllowedTime()
      } else {
        this.percent = 83
      }
    },
    showIntagrationTab: {
      handler(state) {
        this.tab = state ? 0 : 1
      },
      deep: true
    }
  },

  methods: {
    editInstruction(item) {
      this.addFormEditMode = true
      this.isShowingAddForm = true
      this.instructionTypeId = item.id
    },
    openAddForm(item) {
      this.instructionTypeId = item.id
      this.addFormEditMode = false
      this.isShowingAddForm = true
    },
    openPricingScheduleForm() {
      this.editingScheduleItem = null
      this.isPricingScheduleFormOpenings = true
    },
    editSchedule(item) {
      this.editingScheduleItem = item
      this.isPricingScheduleFormOpenings = true
    },
    async sendForReview() {
      const merchantId = this.$route.params.merchantId
      const scheduleId =
        this.$refs.tabPricing.notExpiredPrices[
          this.$refs.tabPricing.currentItem
        ].id
      await merchantHelpers.submitPricingScheduleForReview(
        merchantId,
        scheduleId
      )
      await merchantHelpers.approvePricingScheduleReview(merchantId, scheduleId)
      if (!this.currentProductSettings.is_currency_disabled) {
        this.fetchProductSettings()
      }
      this.showCurrencyApprovePopup = false
      await this.$store.dispatch('setSystemMessage', {
        type: 'success',
        message: this.$t('pricing_activated')
      })
      await this.$store.dispatch('setSystemMessage', {
        type: 'warning',
        message: this.$t('remember_to_update_admin_v2_settings')
      })
      await this.getPricingSchedule()
      await this.$store.dispatch('setShowOverlay', false)
    },
    withdrawReview() {
      this.isScheduleInReview = false
    },
    async fetchMerchant() {
      await this.$store.dispatch('setShowOverlay', true)
      const merchant = await merchantHelpers.fetchMerchant(
        this.$route.params.merchantId
      )
      if (!merchant) {
        await this.$router.push({ name: 'AllMerchants' })
        await this.$store.dispatch('setSidebar', config.SIDEBAR.MERCHANT_ALL)
        return
      }
      await this.$store.dispatch('setCurrentMerchant', merchant)
    },
    async deleteLocationProduct() {
      const productId = 1 // TODO change the route parameters once the product flow is added
      const locationId = parseInt(this.$route.params.locationId)
      const merchantId = parseInt(this.$route.params.locationId)
      await merchantHelpers.deleteLocationProduct(locationId, productId)
      await this.$store.dispatch('setSystemMessage', {
        type: 'delete',
        message: this.$t('visitor_parking_was_removed')
      })
      await this.$router.push({
        name: 'Location',
        params: { merchantId: `${merchantId}`, locationId: `${locationId}` }
      })
      await this.$store.dispatch('setSidebar', config.SIDEBAR.MERCHANT)
    },
    async fetchProductSettings() {
      await this.$store.dispatch('setShowOverlay', true)
      const productId = 1 // TODO change the route parameters once the product flow is added
      const locationId = parseInt(this.$route.params.locationId)
      this.productSettings = await merchantHelpers.getProductAdvancedSettings(
        locationId,
        productId
      )
      this.$store.dispatch('setCurrentProductSettings', this.productSettings)
    },
    async updateProductSettings() {
      const productId = 1 // TODO change the route parameters once the product flow is added
      const locationId = parseInt(this.$route.params.locationId)
      if (this.productSettingsFormData.vat_percentage === "") {
        this.productSettingsFormData.vat_percentage = null
      }
      if (this.productSettingsFormData.kick_back_fee_fixed === "") {
        this.productSettingsFormData.kick_back_fee_fixed = null
      }
      if (this.productSettingsFormData.kick_back_fee_percentage === "") {
        this.productSettingsFormData.kick_back_fee_percentage = null
      }
      if (this.productSettingsFormData.commission_fixed === "") {
        this.productSettingsFormData.commission_fixed = null
      }
      if (this.productSettingsFormData.commission_percentage === "") {
        this.productSettingsFormData.commission_percentage = null
      }

      this.productSettings = {
        ...(await merchantHelpers.updateProductAdvancedSettings(
          locationId,
          productId,
          this.productSettingsFormData
        ))
      }
      this.$store.dispatch('setCurrentProductSettings', this.productSettings)
    },
    async getLocations() {
      const locationId = parseInt(this.$route.params.locationId)
      const locations = await merchantHelpers.getLocationsByMerchant(
        this.$route.params.merchantId
      )
      await this.$store.dispatch('setSidebar', config.SIDEBAR.MERCHANT)
      await this.$store.dispatch('setMerchantLocations', locations)
      for (let i = 0; i < locations?.length; i++) {
        if (locations[i].id === locationId) {
          const location = locations[i]
          await this.$store.dispatch('setCurrentLocation', location)
          await this.$store.dispatch('setCurrentProduct', 1)
          break
        }
      }
    },
    async submitPricingSchedule(formData) {
      const data = Object.fromEntries(
        Object.entries(formData).filter(([key, value]) => value !== null)
      )
      data.location_id = parseInt(this.$route.params.locationId)
      data.product_id = 1
      data.fixed_fee_amount = parseFloat(data.fixed_fee_amount)
      const pricing = await merchantHelpers.createPricingSchedule(
        this.$route.params.merchantId,
        data
      )
      if (pricing) {
        this.schedulePrices.push(pricing)
        this.$refs.tabPricing.currentItem = this.$refs.tabPricing
          ?.notExpiredPrices?.length
          ? this.$refs.tabPricing?.notExpiredPrices?.length
          : 0
        await this.$refs.tabPricing.getPricingDetails(pricing.id)
        await this.$refs.tabPricing.getSequencePricesPeriod()
        this.isPricingScheduleFormOpenings = false
        await this.$store.dispatch('setSystemMessage', {
          type: 'success',
          message: this.$t('schedule_is_added')
        })
        await this.$store.dispatch('setSystemMessage', {
          type: 'warning',
          message: this.$t('remember_to_update_admin_v2_settings')
        })
      }
    },
    async updatePricingSchedule(formData) {
      const data = Object.fromEntries(
        Object.entries(formData).filter(([key, value]) => value !== null)
      )
      data.fixed_fee_amount = parseFloat(data.fixed_fee_amount)
      const pricing = await merchantHelpers.updatePricingSchedule(
        this.$route.params.merchantId,
        formData.id,
        data
      )
      if (pricing) {
        const newSchedule = pricing?.schedule[0]
        const index = this.schedulePrices.findIndex(
          (schedule) => schedule.id === newSchedule.id
        )
        if (index !== -1) {
          this.schedulePrices.splice(index, 1, newSchedule)
          this.$refs.tabPricing.priceDetails = pricing
        }
        await this.getPricingSchedule()
        this.isPricingScheduleFormOpenings = false
        await this.$store.dispatch('setSystemMessage', {
          type: 'success',
          message: this.$t('schedule_updated')
        })
        await this.$store.dispatch('setSystemMessage', {
          type: 'warning',
          message: this.$t('remember_to_update_admin_v2_settings')
        })
      }
    },
    async deletePricingSchedule(item) {
      await merchantHelpers.deletePricingSchedule(
        this.$route.params.merchantId,
        item
      )
      await this.getPricingSchedule()
      this.isPricingScheduleFormOpenings = false
      await this.$store.dispatch('setSystemMessage', {
        type: 'error',
        message: this.$t('price_is_removed', { object: 'Schedule price' })
      })
      await this.$store.dispatch('setSystemMessage', {
        type: 'warning',
        message: this.$t('remember_to_update_admin_v2_settings')
      })
    },
    async getPricingSchedule() {
      if (this.currentLocation === null) {
        await this.fetchMerchant()
        await this.getLocations()
      }
      this.schedulePrices = await merchantHelpers.getPricingSchedule(
        this.$route.params.merchantId,
        parseInt(this.$route.params.locationId)
      )
    },
    async getPricingStatus() {
      await merchantHelpers.getPricingStatus()
    },
    scrollToElement() {
      const locationId = this.$route.params.locationId
      if (!locationId) {
        return
      }

      const el = this.$el.querySelector(
        `.location-list-item[data-id='${locationId}']`
      )

      if (el) {
        el.scrollIntoView()
      }
    },
    cancelChanges() {
      this.productSettings = { ...this.productSettings }
    },
    openNextTab() {
      if (Object.keys(TAB)?.length >= this.tab) {
        this.tab++
      }
    },
    checkCurrencyApproval() {
      if (!this.currentProductSettings.is_currency_disabled) {
        this.showCurrencyApprovePopup = true
      } else {
        this.sendForReview()
      }
    },
    async getHubsList() {
      const merchantId = this.$route.params.merchantId
      const locationId = this.$route.params.locationId
      const response = await merchantHelpers.fetchMerchantLocationHubs(merchantId, locationId)
      this.hubsList = response ? [response] : []
    },
    async getWardensList() {
      const merchantId = this.$route.params.merchantId
      const locationId = this.$route.params.locationId
      const response = await merchantHelpers.fetchMerchantLocationWardens(merchantId, locationId)
      this.wardensList = response.wardens
    },
    async openEditDiscountForm(discount) {
      this.selectedDiscount = discount

      if (discount.discount_type === 'eco_car_discount') {
        this.selectedDiscount = discount
        this.isEcoCarDiscountFormOpening = true
      }
      if (discount.discount_type === 'holiday_discount') {
        await this.fetchHolidays(discount)
        this.isHolidaysFormOpening = true
      }
    },
    currentLocationProductId() {
      const lp = (this.currentLocation?.location_products || []).find(
        (x) => x.product_id === 1
      )
      return lp ? lp.id : null
    },
    async fetchLocationProductsDiscounts() {
      const merchantId = this.$route.params.merchantId
      const lpId = this.currentLocationProductId()
      const [holidayLists, ecoCarLists] = await Promise.all([
        lpId
          ? merchantHelpers.fetchLocationProductHolidayLists(merchantId, lpId)
          : Promise.resolve([]),
        lpId
          ? merchantHelpers.fetchLocationProductEcoCarsLists(merchantId, lpId)
          : Promise.resolve([])
      ])
      const toV1Shape = (d) => ({
        ...d,
        list_id: d.discount_list_id,
        discount_template_id: d.discount_list_id,
        type: d.discount_level || d.type,
        locations_quantity: d.locations_quantity ?? null
      })
      const holiday = (holidayLists || []).map(toV1Shape)
      const ecoCar = (ecoCarLists || []).map((d) => ({
        ...toV1Shape(d),
        // normalize: spec examples use eco_cars_discount, schema enum uses
        // eco_car_discount — the UI branches on the singular form
        discount_type: 'eco_car_discount'
      }))
      this.discounts = [...holiday, ...ecoCar]
    },
    async saveDiscount(payload) {
      const merchantId = this.$route.params.merchantId
      const discount = this.selectedDiscount
      const listId =
        payload.list_id || discount.list_id || discount.discount_list_id
      const lpId = this.currentLocationProductId()
      if (!lpId) return

      const originalIds = new Set(
        (this.holidays || []).map((h) => h.holiday_date_id).filter(Boolean)
      )
      const currentIds = new Set(
        payload.holidays.map((h) => h.holiday_date_id).filter(Boolean)
      )

      const idsToDelete = [...originalIds].filter((id) => !currentIds.has(id))
      const datesToAdd = payload.holidays
        .filter((h) => !h.holiday_date_id && h.holiday_date)
        .map((h) => h.holiday_date)

      for (const id of idsToDelete) {
        await merchantHelpers.deleteHolidayDate(merchantId, id, listId)
      }

      let addResult = null
      if (datesToAdd.length > 0) {
        addResult = await merchantHelpers.addLocationProductHolidayDates(
          merchantId,
          lpId,
          listId,
          datesToAdd
        )
      }

      if (payload.valid_to !== discount.valid_to) {
        await merchantHelpers.updateLocationProductHolidayList(
          merchantId,
          lpId,
          listId,
          { valid_to: payload.valid_to }
        )
      }

      this.isHolidaysFormOpening = false
      await this.fetchLocationProductsDiscounts()
      const rejected = addResult?.rejected_dates || []
      if (rejected.length > 0) {
        await this.$store.dispatch('setSystemMessage', {
          type: 'warning',
          message: `Some dates were rejected by the server: ${rejected.join(', ')}`
        })
      } else {
        await this.$store.dispatch('setSystemMessage', {
          type: 'success',
          message: 'Holiday dates updated'
        })
      }
    },
    openDeleteDiscountConfirm(discount) {
      this.deletingDiscount = discount
      this.isDeleteDiscountConfirmOpening = true
    },
    async openCountryHolidaysPopup(discount) {
      this.selectedDiscount = discount
      await this.fetchHolidays(discount)
      this.isCountryHolidaysPopupOpening = true
    },
    async confirmDeleteDiscount() {
      const merchantId = this.$route.params.merchantId
      const discount = this.deletingDiscount
      const listId =
        discount.list_id ||
        discount.discount_list_id ||
        discount.discount_template_id
      const lpId = this.currentLocationProductId()

      let result = false
      if (discount.discount_type === 'holiday_discount' && lpId) {
        result = await merchantHelpers.deleteLocationProductHolidayList(
          merchantId,
          lpId,
          listId
        )
      } else if (discount.discount_type === 'eco_car_discount' && lpId) {
        result = await merchantHelpers.deleteLocationProductEcoCarsList(
          merchantId,
          lpId,
          listId
        )
      }
      this.isDeleteDiscountConfirmOpening = false
      if (result) {
        await this.fetchLocationProductsDiscounts()
        await this.$store.dispatch('setSystemMessage', {
          type: 'success',
          message: 'Discount list deleted'
        })
      }
      this.deletingDiscount = null
    },
    async fetchHolidays(item) {
      const merchantId = this.$route.params.merchantId
      const listId = item.list_id || item.discount_list_id
      const isLocationProduct =
        (item.discount_level || item.type) === 'location_product'

      let holidays
      if (isLocationProduct) {
        const lpId = this.currentLocationProductId()
        holidays = lpId
          ? await merchantHelpers.fetchLocationProductHolidayDates(
              merchantId,
              lpId,
              listId
            )
          : []
      } else {
        holidays = await merchantHelpers.fetchMerchantHolidayDates(
          merchantId,
          listId
        )
      }
      this.holidays = Array.isArray(holidays) ? holidays : []
    },
    async fetchDiscountedLocations(item) {
      const listId = item.list_id || item.discount_template_id
      const locations =
        item.discount_type === 'holiday_discount'
          ? await merchantHelpers.fetchHolidayListLocations(
              this.$route.params.merchantId,
              listId
            )
          : await merchantHelpers.fetchEcoCarsListLocations(
              this.$route.params.merchantId,
              listId
            )
      this.discountLocations = locations || []
      this.isDiscountLocationsFormOpening = true
    },
    async openDiscountedLocationsForm(item) {
      await this.fetchDiscountedLocations(item)
    },
    async addWarden(record) {
      const locationId = this.$route.params.locationId
      await merchantHelpers.createLocationAndWardenConnection(locationId, record)
      await this.getWardensList()
    },
    async deleteWarden(record) {
      const locationId = this.$route.params.locationId
      await merchantHelpers.deleteLocationAndWardenConnection(locationId, record.id)
      await this.getWardensList()
    },
    async openAddHubForm() {
      const merchantId = this.$route.params.merchantId
      const data = await merchantHelpers.fetchMerchantHubs(merchantId)
      this.merchantHubsList = data
      this.isShowingAddHubPopup = true
    },
    async addHub(record) {
      const merchantId = this.$route.params.merchantId
      const locationId = this.$route.params.locationId
      const data = {location_id: locationId, merchant_id: merchantId, hub_location_code: record.hub_location_code, hub_name: record.hub_name}
      await merchantHelpers.addHubToLocation(data)
      await this.getHubsList()
      this.isShowingAddHubPopup = false
    },
    async deleteHub() {
      const locationId = this.$route.params.locationId
      await merchantHelpers.deleteHubFromLocation(locationId)
      this.isShowingDeleteHubPopup = false
      this.hubsList = []
    },
    showAddRestrictionsForm() {
      this.editAllowedTimeItem = null
      this.isShowingAddRestrictionsPopup = true
    },
    async fetchAllowedTime() {
      const merchantId = this.$route.params.merchantId 
      const locationId = this.$route.params.locationId
      this.allowedTime = await merchantHelpers.fetchLocationProductAllowedTime(merchantId, locationId, 1)
    },
    async submitAllowedTime(item) {
      if (item.ids) {
        await this.submitEdittingAllowedTime(item)
      } else {
        await this.submitCreatingAllowedTime(item)
      }
    },
    showEditAllowedTimeForm(item) {
      this.editAllowedTimeItem = item
      this.isShowingAddRestrictionsPopup = true
    },
    async submitCreatingAllowedTime(item) {
      const locationId = this.$route.params.locationId 
      const merchantId = this.$route.params.merchantId 

      const weekday = item.weekday
      const requests = weekday.map(day => {
      const requestData = {
        day_of_week_start: day,
        day_of_week_end: day,
        time_of_day_start: item.time_of_day_start,
        time_of_day_end: item.time_of_day_end,
        valid_from: item.valid_from,
        valid_to: item.valid_to
      }

        return merchantHelpers.createLocationProductAllowedTime(merchantId, locationId, 1, requestData)
      })
        try {
        await Promise.all(requests)
        await this.fetchAllowedTime()
        this.isShowingAddRestrictionsPopup = false
      } catch (error) {
        console.error('One or more requests failed:', error)
      }
    },
    async submitEdittingAllowedTime(item) {
      const merchantId = this.$route.params.merchantId 
      const locationId = this.$route.params.locationId
      const data = {time_period_ids: item.ids, valid_to: item.valid_to}
      await merchantHelpers.updateAllowedTimeValidUntil(merchantId, locationId, data)
      this.isShowingAddRestrictionsPopup = false
      await this.fetchAllowedTime()
    },
    showAddANPRPopup() {
      this.isShowingAddANPRForm = true
    },
    async getLocationAnprConnections() {
      this.getAnprConfig()
      const locationId = this.$route.params.locationId
      const connection = await merchantHelpers.getLocationAnprConnections(locationId)
      this.cameraConnection = this.transformFeatures(connection)
    },
    async addAnprConnection(data) {
      const locationId = this.$route.params.locationId
      const connection = await merchantHelpers.createLocationAnprConnection(locationId, data)
      this.cameraConnection = this.transformFeatures(connection)
      this.isShowingAddANPRForm = false
    },
    transformFeatures(data) {
      if (data === null) { return }
      const startFeatures = []
      let stopFeature = null

      data.product_features.forEach(feature => {
        if (feature.includes("_start")) {
          startFeatures.push(feature)
        } else if (feature.includes("_stop")) {
          stopFeature = feature
        }
      })

      return {
        location_id: data.location_id,
        product_id: data.product_id,
        integrator_id: data.integrator_id,
        integrator_location_code: data.integrator_location_code,
        start: startFeatures,
        stop: stopFeature
      }
    },
    async deleteAnpr() {
      const locationId = this.$route.params.locationId
      await merchantHelpers.deleteLocationAnprConnection(locationId)
      this.cameraConnection = null
    },
    async getAnprConfig() {
      if (this.anprConfig === null) {
        const configs = await merchantHelpers.getAnprConfig()

        const featureDisplayMap = {
          camera_auto_start: "Automatic",
          camera_manual_start: "Manual",
          camera_auto_stop: "Automatic"
        }
        const types = ["start", "stop"]
        types.forEach(type => {
          configs.features[type] = configs.features[type].map(feature => ({
            ...feature,
            displayName: featureDisplayMap[feature.name] || "Unknown"
          }))
        })
        this.anprConfig = configs
      }
    },
  },
  async mounted() {
    await this.$store.dispatch('setShowOverlay', true)

    await Promise.all([
      this.getHubsList(),
      this.getWardensList(),
      this.fetchProductSettings(),
      this.getPricingSchedule(),
      this.getLocationAnprConnections()
    ])

    await this.$store.dispatch('setShowOverlay', false)

    this.scrollToElement()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/style/common';
@import '~@/style/variables';

.tab-item {
  overflow-y: auto;
  transition: false;
}

.v-window__container {
  height: 100%;
}

.button-panel {
  padding: 0px 68px 40px;
}
.top-container {
  padding-top: 16px !important;
  text-align: start;
  height: 134px !important;
}
.top-container-title-label {
  padding-top: $page-vertical-padding;
  padding-left: 56px;
}

.pricing-divider {
  margin-right: 195px;
}

.warden-divider {
  margin-right: 205px;
}

.bottom-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 180px;
}

.add-price-schedule-button {
  width: 180px;
  height: 46px;
}
</style>
